export default {
	CORRIDOS: { text: 'Corridos', value: 'CORRIDOS' },
	UTEIS: { text: 'Úteis', value: 'UTEIS' },
}
